import { makeCRUDSlice } from '@redux/crudCreator';
import { MODEL_NAME, variantRelatedActions } from './actions';

const slice = makeCRUDSlice(MODEL_NAME, variantRelatedActions);

export default slice.reducer;
